import Event from '../Event';
import createUid from '../util/uid';

/** Custom event */
class CustomEvent extends Event {
	/** @param {object} args - Custom event args */
	constructor(args) {
		super(args);

		// tag each datapoint with a uid
		this.params.dataset.forEach(datum => {
			datum.uid = createUid();
		});
	}
	/**
	 * Overrides abstract method in Event class. Sets default params for this event
	 * @returns {object} object with event information
	 * @override
	 * @private
	 */
	getDefaultParams() {
		return {
			id: 'custom',
			name: 'Custom',
			dataset: [],
			renderMethod: null,
			removeMethod: null
		};
	}
	/**
	 * Adds a new event data point to the event dataset
	 * @param {object} datapoint - the new event data point to add
	 * @returns {datapoint} returns newly created datapoint with attached uid
	 */
	addDatapoint(datapoint) {
		if (datapoint) {
			// add a uid
			datapoint.uid = createUid();

			this.params.dataset.push(datapoint);

			return datapoint;
		}
	}
	/**
	 * Removes an event data point based on the point's uid
	 * @param {number} uid - unique chart identifier for the data point
	 */
	removeDatapointByUid(uid) {
		if (uid) {
			for (let x = this.params.dataset.length - 1; x >= 0; x--) {
				if (this.params.dataset[x].uid === uid) {
					this.params.dataset.splice(x, 1);
				}
			}
		}
	}
	/**
	 * Perform developer-defined actions before removal
	 */
	remove() {
		if (this.params.removeMethod) {
			this.params.removeMethod(this);
		}
	}
	/**
	 * Overrides abstract method in Event class. Sets default render params for
	 * this event based on custom render method provided in initial args
	 * @override
	 */
	render(data) {
		if (this.params.renderMethod && this.params.dataset) { // backward compatible for v1 handling
			this.params.renderMethod(this.coords, this);
		} else {
			this.renderDefault(data, this.params.id, '#97BEF9', 'C');
		}
	}
}

export default CustomEvent;
